var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _path16, _g8, _mask, _path17, _path18, _mask2, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 169,
    viewBox: "0 0 100 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34338 39.9662C7.34338 39.9662 42.7782 37.5707 43.0195 75.1612C4.91964 74.9228 7.34338 39.9662 7.34338 39.9662Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 36,
    width: 41,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17188 36.9395H45.8819V77.5325H5.17188V36.9395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.105 77.2231L43.0212 77.2122C30.7325 77.1309 21.1747 73.5594 14.6108 66.5789C4.33459 55.6584 5.26131 40.4834 5.30518 39.8439L5.42582 38.0825L7.21895 37.9579C7.21895 37.9579 7.72344 37.9199 8.61178 37.9199C14.6656 37.9199 44.8637 39.7192 45.094 75.1636L45.105 77.2231Z",
    fill: "url(#paint0_linear_13876_66175)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 0,
    width: 31,
    height: 57
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6406 0.00195312H64.1203V56.3607H34.6406V0.00195312Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5569 55.6471L48.0928 54.1838C39.4561 45.5558 35.2612 36.3587 35.6231 26.8472C36.1879 11.9541 47.7144 1.87355 48.2079 1.45624L49.5569 0.291016L50.9113 1.45624C51.4049 1.87355 62.9313 11.9541 63.4961 26.8472C63.8581 36.3587 59.6631 45.5558 51.0265 54.1838L49.5569 55.6471Z",
    fill: "url(#paint1_linear_13876_66175)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7465 39.9662C92.7465 39.9662 57.3171 37.5707 57.0703 75.1612C95.1757 74.9228 92.7465 39.9662 92.7465 39.9662Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 36,
    width: 41,
    height: 42
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2812 36.9395H94.9913V77.5325H54.2812V36.9395Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0078 77.2231L55.0243 75.1636C55.2546 39.7192 85.4526 37.9199 91.501 37.9199C92.3948 37.9199 92.8993 37.9579 92.8993 37.9579L94.687 38.0825L94.8131 39.8439C94.857 40.4834 95.7837 55.6529 85.5075 66.5789C78.9491 73.5594 69.3857 77.1309 57.0916 77.2122L55.0078 77.2231Z",
    fill: "url(#paint2_linear_13876_66175)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 60,
    width: 96,
    height: 109
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 60.0137H97.8018V168.591H2.34375V60.0137Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13876_66175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 60,
    width: 94,
    height: 109
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2012 168.598V60.1076C66.8777 60.0859 66.5596 60.0859 66.2361 60.0859H33.9488V168.598H67.2012ZM25.6741 168.598H33.9488V60.1076H33.7678C20.3879 60.1076 8.64209 70.8981 7.67698 84.0732L3.15303 144.659C2.1605 157.807 12.2996 168.598 25.6741 168.598ZM74.3244 168.598C87.7043 168.598 97.8379 157.807 96.8509 144.632L92.3215 84.0515C91.3564 71.1962 80.1424 60.6116 67.1793 60.1076V168.598H74.3244Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9098 168.598H3.14062V60.0215H96.9098V168.598Z",
    fill: "url(#paint3_linear_13876_66175)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0859 95.0391H26.6094V168.592H20.0859C17.8768 168.592 16.0859 166.801 16.0859 164.592V95.0391Z",
    fill: "url(#paint4_linear_13876_66175)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3516 95.0391H82.875V165.592C82.875 167.249 81.5319 168.592 79.875 168.592H72.3516V95.0391Z",
    fill: "url(#paint5_linear_13876_66175)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 57,
    width: 44,
    height: 43
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 57.2715H43.6999V99.5121H0.960938V57.2715Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13876_66175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 57,
    width: 44,
    height: 43
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3304 57.2832C10.5298 57.2832 0.960938 66.735 0.960938 78.4035C0.960938 90.0665 10.5298 99.5238 22.3304 99.5238C34.1311 99.5238 43.6999 90.0665 43.6999 78.4035C43.6999 66.735 34.1311 57.2832 22.3304 57.2832Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 57.2832H43.6999V99.5238H0.960938V57.2832Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 64,
    width: 29,
    height: 28
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 64.8027H36.0635V91.9269H8.625V64.8027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13876_66175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 64,
    width: 29,
    height: 28
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3443 64.8027C14.7676 64.8027 8.625 70.8737 8.625 78.3676C8.625 85.8559 14.7676 91.9269 22.3443 91.9269C29.9209 91.9269 36.0635 85.8559 36.0635 78.3676C36.0635 70.8737 29.9209 64.8027 22.3443 64.8027Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 64.8027H36.0635V91.9269H8.625V64.8027Z",
    fill: "#3D1F1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5557 55.3105V101.419H-0.867188V55.3105H45.5557Z",
    fill: "#3D1F1E",
    stroke: "#3D1F1E",
    strokeWidth: 18.985
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 57,
    width: 44,
    height: 43
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3203 57.3145H99.0593V99.555H56.3203V57.3145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13876_66175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 57,
    width: 44,
    height: 43
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6898 57.3262C65.8837 57.3262 56.3203 66.778 56.3203 78.4465C56.3203 90.1095 65.8837 99.5668 77.6898 99.5668C89.4905 99.5668 99.0593 90.1095 99.0593 78.4465C99.0593 66.778 89.4905 57.3262 77.6898 57.3262Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3203 57.3262H99.0593V99.5668H56.3203V57.3262Z",
    fill: "white"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7266 113.969C50.4679 113.969 51.2009 114.031 51.9258 114.156C52.6549 114.279 53.3598 114.464 54.0439 114.708C54.728 114.954 55.3797 115.252 55.9941 115.606C56.6125 115.961 57.1818 116.365 57.7061 116.815C58.2304 117.269 58.6978 117.759 59.1074 118.291C59.5211 118.82 59.8688 119.382 60.1514 119.971C60.434 120.562 60.6475 121.17 60.7949 121.796C60.9383 122.421 61.0078 123.055 61.0078 123.692C61.0078 124.333 60.9383 124.964 60.7949 125.592C60.6475 126.217 60.434 126.825 60.1514 127.414C59.8687 128.005 59.5211 128.567 59.1074 129.097C58.9157 129.346 58.7106 129.584 58.493 129.815C58.2801 130.04 57.9117 129.902 57.8633 129.596C57.7549 128.93 57.5983 128.282 57.3906 127.652C57.183 127.026 56.9279 126.428 56.624 125.864C56.3231 125.298 55.9799 124.775 55.5947 124.293C55.2096 123.813 54.7912 123.383 54.3369 123.006C53.8856 122.628 53.4068 122.311 52.9043 122.049C52.4018 121.789 51.8842 121.592 51.3486 121.461C50.816 121.327 50.2771 121.262 49.7324 121.262C49.1877 121.262 48.6489 121.327 48.1162 121.461C47.5806 121.592 47.0631 121.789 46.5605 122.049C46.058 122.311 45.5793 122.628 45.1279 123.006C44.6736 123.383 44.2552 123.813 43.8701 124.293C43.4849 124.775 43.1417 125.298 42.8408 125.864C42.537 126.428 42.2818 127.026 42.0742 127.652C41.8666 128.282 41.7099 128.93 41.6016 129.596C41.5525 129.906 41.1783 130.046 40.9626 129.818C40.7441 129.587 40.5382 129.347 40.3457 129.097C39.932 128.567 39.5834 128.005 39.3008 127.414C39.0182 126.826 38.8056 126.217 38.6582 125.592C38.5148 124.964 38.4453 124.333 38.4453 123.692C38.4453 123.055 38.5149 122.421 38.6582 121.796C38.8057 121.17 39.0182 120.562 39.3008 119.971C39.5834 119.382 39.932 118.821 40.3457 118.291C40.7553 117.759 41.2228 117.269 41.7471 116.815C42.2713 116.365 42.8406 115.961 43.459 115.606C44.0734 115.252 44.7251 114.954 45.4092 114.708C46.0931 114.464 46.7974 114.279 47.5264 114.156C48.2514 114.031 48.9851 113.969 49.7266 113.969Z",
    fill: "#3D1F1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 64,
    width: 29,
    height: 29
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9062 64.8027H91.4401V92.0155H63.9062V64.8027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13876_66175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_13876_66175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 64,
    width: 29,
    height: 29
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.676 64.8027C70.0689 64.8027 63.9062 70.8936 63.9062 78.4119C63.9062 85.9247 70.0689 92.0155 77.676 92.0155C85.2774 92.0155 91.4401 85.9247 91.4401 78.4119C91.4401 70.8936 85.2774 64.8027 77.676 64.8027Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_13876_66175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9062 64.8027H91.4401V92.0155H63.9062V64.8027Z",
    fill: "#3D1F1E"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-1_13876_66175",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 71.4023C30.7284 71.4026 33.9998 74.674 34 78.709C34 82.7442 30.7285 86.0154 26.6934 86.0156C25.889 86.0156 25.1154 85.8836 24.3916 85.6436C24.0193 87.5617 22.3317 89.0098 20.3047 89.0098C18.0047 89.0097 16.1407 87.1456 16.1406 84.8457C16.1406 82.7612 17.6717 81.0338 19.6709 80.7285C19.4868 80.0871 19.3867 79.4096 19.3867 78.709C19.3869 74.6738 22.6581 71.4023 26.6934 71.4023Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 71.4023C30.7284 71.4026 33.9998 74.674 34 78.709C34 82.7442 30.7285 86.0154 26.6934 86.0156C25.889 86.0156 25.1154 85.8836 24.3916 85.6436C24.0193 87.5617 22.3317 89.0098 20.3047 89.0098C18.0047 89.0097 16.1407 87.1456 16.1406 84.8457C16.1406 82.7612 17.6717 81.0338 19.6709 80.7285C19.4868 80.0871 19.3867 79.4096 19.3867 78.709C19.3869 74.6738 22.6581 71.4023 26.6934 71.4023Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 71.4023L26.6934 69.9023H26.6934V71.4023ZM34 78.709H35.5V78.7089L34 78.709ZM26.6934 86.0156V87.5156H26.6934L26.6934 86.0156ZM24.3916 85.6436L24.8639 84.2198L23.2443 83.6826L22.9191 85.3577L24.3916 85.6436ZM20.3047 89.0098L20.3047 90.5098H20.3047V89.0098ZM16.1406 84.8457H14.6406V84.8457L16.1406 84.8457ZM19.6709 80.7285L19.8973 82.2113L21.5832 81.9539L21.1127 80.3147L19.6709 80.7285ZM19.3867 78.709L17.8867 78.7089V78.709H19.3867ZM26.6934 71.4023L26.6933 72.9023C29.8999 72.9025 32.4998 75.5024 32.5 78.7091L34 78.709L35.5 78.7089C35.4997 73.8455 31.5568 69.9026 26.6934 69.9023L26.6934 71.4023ZM34 78.709H32.5C32.5 81.9157 29.9002 84.5154 26.6933 84.5156L26.6934 86.0156L26.6934 87.5156C31.5569 87.5154 35.5 83.5727 35.5 78.709H34ZM26.6934 86.0156V84.5156C26.0541 84.5156 25.4398 84.4109 24.8639 84.2198L24.3916 85.6436L23.9193 87.0673C24.791 87.3564 25.7239 87.5156 26.6934 87.5156V86.0156ZM24.3916 85.6436L22.9191 85.3577C22.6809 86.5847 21.5995 87.5098 20.3047 87.5098V89.0098V90.5098C23.064 90.5098 25.3576 88.5388 25.8641 85.9294L24.3916 85.6436ZM20.3047 89.0098L20.3047 87.5098C18.8332 87.5097 17.6407 86.3172 17.6406 84.8457L16.1406 84.8457L14.6406 84.8457C14.6407 87.9741 17.1763 90.5097 20.3047 90.5098L20.3047 89.0098ZM16.1406 84.8457H17.6406C17.6406 83.5129 18.62 82.4064 19.8973 82.2113L19.6709 80.7285L19.4445 79.2457C16.7234 79.6612 14.6406 82.0095 14.6406 84.8457H16.1406ZM19.6709 80.7285L21.1127 80.3147C20.9662 79.8043 20.8867 79.2661 20.8867 78.709H19.3867H17.8867C17.8867 79.5532 18.0074 80.3698 18.2291 81.1423L19.6709 80.7285ZM19.3867 78.709L20.8867 78.7091C20.8869 75.5022 23.4866 72.9023 26.6934 72.9023V71.4023V69.9023C21.8296 69.9023 17.887 73.8454 17.8867 78.7089L19.3867 78.709Z",
    fill: "#3D1F1E",
    mask: "url(#path-28-inside-1_13876_66175)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-2_13876_66175",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3379 71.4023C69.3027 71.4023 66.0315 74.6738 66.0312 78.709C66.0312 82.7443 69.3025 86.0156 73.3379 86.0156C74.142 86.0156 74.915 85.8836 75.6387 85.6436C76.011 87.5617 77.6986 89.0097 79.7256 89.0098C82.0256 89.0098 83.8906 87.1457 83.8906 84.8457C83.8906 82.7611 82.3587 81.0337 80.3594 80.7285C80.5435 80.0871 80.6445 79.4096 80.6445 78.709C80.6443 74.674 77.3729 71.4026 73.3379 71.4023Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3379 71.4023C69.3027 71.4023 66.0315 74.6738 66.0312 78.709C66.0312 82.7443 69.3025 86.0156 73.3379 86.0156C74.142 86.0156 74.915 85.8836 75.6387 85.6436C76.011 87.5617 77.6986 89.0097 79.7256 89.0098C82.0256 89.0098 83.8906 87.1457 83.8906 84.8457C83.8906 82.7611 82.3587 81.0337 80.3594 80.7285C80.5435 80.0871 80.6445 79.4096 80.6445 78.709C80.6443 74.674 77.3729 71.4026 73.3379 71.4023Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3379 71.4023V69.9023H73.338L73.3379 71.4023ZM66.0312 78.709H64.5312V78.7089L66.0312 78.709ZM73.3379 86.0156L73.338 87.5156H73.3379V86.0156ZM75.6387 85.6436L75.1664 84.2198L76.786 83.6826L77.1112 85.3577L75.6387 85.6436ZM79.7256 89.0098V90.5098H79.7256L79.7256 89.0098ZM83.8906 84.8457H85.3906V84.8457L83.8906 84.8457ZM80.3594 80.7285L80.133 82.2113L78.4471 81.954L78.9176 80.3147L80.3594 80.7285ZM80.6445 78.709L82.1445 78.7089V78.709H80.6445ZM73.3379 71.4023V72.9023C70.1312 72.9023 67.5314 75.5022 67.5312 78.7091L66.0312 78.709L64.5312 78.7089C64.5315 73.8454 68.4742 69.9023 73.3379 69.9023V71.4023ZM66.0312 78.709H67.5312C67.5312 81.9159 70.131 84.5156 73.3379 84.5156V86.0156V87.5156C68.4741 87.5156 64.5312 83.5728 64.5312 78.709H66.0312ZM73.3379 86.0156L73.3378 84.5156C73.9767 84.5156 74.5905 84.4109 75.1664 84.2198L75.6387 85.6436L76.1109 87.0673C75.2396 87.3563 74.3074 87.5156 73.338 87.5156L73.3379 86.0156ZM75.6387 85.6436L77.1112 85.3577C77.3493 86.5846 78.4308 87.5097 79.7256 87.5098L79.7256 89.0098L79.7256 90.5098C76.9664 90.5097 74.6727 88.5388 74.1662 85.9294L75.6387 85.6436ZM79.7256 89.0098V87.5098C81.1976 87.5098 82.3906 86.3168 82.3906 84.8457L83.8906 84.8457L85.3906 84.8457C85.3906 87.9745 82.8536 90.5098 79.7256 90.5098V89.0098ZM83.8906 84.8457H82.3906C82.3906 83.5133 81.4108 82.4064 80.133 82.2113L80.3594 80.7285L80.5857 79.2457C83.3065 79.661 85.3906 82.009 85.3906 84.8457H83.8906ZM80.3594 80.7285L78.9176 80.3147C79.0645 79.8029 79.1445 79.2647 79.1445 78.709H80.6445H82.1445C82.1445 79.5546 82.0225 80.3712 81.8012 81.1423L80.3594 80.7285ZM80.6445 78.709L79.1445 78.7091C79.1444 75.5024 76.5445 72.9025 73.3378 72.9023L73.3379 71.4023L73.338 69.9023C78.2014 69.9026 82.1443 73.8455 82.1445 78.7089L80.6445 78.709Z",
    fill: "#3D1F1E",
    mask: "url(#path-30-inside-2_13876_66175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13876_66175",
    x1: 25.1853,
    y1: 37.9199,
    x2: 25.1853,
    y2: 77.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13876_66175",
    x1: 49.5596,
    y1: 0.291016,
    x2: 49.5596,
    y2: 55.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13876_66175",
    x1: 74.9302,
    y1: 37.9199,
    x2: 74.9302,
    y2: 77.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13876_66175",
    x1: 50.0252,
    y1: 60.0215,
    x2: 50.0252,
    y2: 168.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13876_66175",
    x1: 21.3477,
    y1: 95.0391,
    x2: 21.3477,
    y2: 168.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13876_66175",
    x1: 77.6133,
    y1: 95.0391,
    x2: 77.6133,
    y2: 168.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoCry);
export default __webpack_public_path__ + "static/media/pikkoCry.990000aa7828daf7271267ed276959ca.svg";
export { ForwardRef as ReactComponent };